import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IntelligentFourCornersComponent, photoCaptureFileUploadFailedAction, photoCaptureIntelligentViewChangeAction, photoCaptureIntelligentPhotoUploadSuccessAction } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestion } from "../../../domain/questionnaireEvaluation";
import { getGPCTheme } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        photoCaptureFileUploadFailedAction,
        onViewChange: photoCaptureIntelligentViewChangeAction,
        onSelectedFileUpload: photoCaptureIntelligentPhotoUploadSuccessAction
    }, dispatch);
};
const IntelligentFourCornerComponentWrapper = (props) => React.createElement(IntelligentFourCornersComponent, Object.assign({}, props));
export const ConnectedIntelligentFourCornersComponent = connect(mapStateToProps, mapDispatchToProps)(IntelligentFourCornerComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentFourCornersComponent.js.map